export default __webpack_public_path__ + "8179dbd19947aa4359884cb16bc688ca.png";